import React from 'react';
import './EventInclusions.css';

export const EventInclusions = ({ inclusions = [] }) => {
  if (!inclusions || inclusions.length === 0) {
    return null;
  }

  return (
    <div className="event-inclusions-section">
      <div className="page-padding-">
        <div className="container-medium">
          <div className="padding-vertical padding-small">
            <div className="inclusions-wrapper">
              <div className="inclusions-header">
                <h2 className="heading-7">What's Included</h2>
              </div>
              <div className="inclusions-list">
                {inclusions.map((item) => (
                  <div key={item.id || item._id} className="inclusion-item">
                    <span className="inclusion-text">{item.text}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
        <div className="site_content-divider"></div>
      </div>
    </div>
  );
};

export default EventInclusions;
